import { render, staticRenderFns } from "./TermsAndConditionsModal.vue?vue&type=template&id=4239f3c2&"
import script from "./TermsAndConditionsModal.vue?vue&type=script&lang=ts&"
export * from "./TermsAndConditionsModal.vue?vue&type=script&lang=ts&"
import style0 from "./TermsAndConditionsModal.vue?vue&type=style&index=0&id=4239f3c2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports